module.exports = __webpack_public_path__ + "h5-static/img/loading_750x320.3f6d932b.gif";